import GenericTable from "../Tables/GenericTable";
import MDButton from "components/MDButton";
import DefaultCell from "../Tables/components/DefaultCell";
import { GET_ALL_QUERY, GetAllGql, GetAllItem } from "./queries/getAll";
import { getStatusCell } from "../Tables/GenericTable/utils/getStatusCell";
import { Sites } from "data/utils/globals";
import { ModalTableSelect } from "../JsonForm/renderers/SelectMultiple/types";
import ModalCustom from "../ModalCustom";

const btnStyle = {
  border: "1px solid #7b809a",
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 1,
};

const btnStyleRemove = {
  ...btnStyle,
  border: "1px solid #F44335",
  color: "#F44335",
};

export default function ModalEventsSelect({ ids, handleOpen, onChange, open }: ModalTableSelect) {
  return (
    <ModalCustom
      onClose={handleOpen}
      open={open}
      sx={{
        "& .head": {
          justifyContent: "center",
          width: "100%",
        },
      }}
    >
      <GenericTable<GetAllGql>
        initialVariables={{
          page: 1,
          perPage: 8,
          search: null,
          status: null,
        }}
        path={`${Sites.UNIFTEC.path}/eventos`}
        query={GET_ALL_QUERY}
        formatRows={(data) => data.Events.items}
        formatPagination={(data) => data.Events.paginationInfo}
        columnsTable={[
          {
            Header: "Ação",
            accessor: "id",
            Cell: ({ value, cell }: any) => (
              <MDButton
                sx={ids.includes(Number(value)) ? btnStyleRemove : btnStyle}
                onClick={() => {
                  const data = cell.row.original as GetAllItem;
                  onChange({ ...data, name: data.title });
                }}
              >
                {ids.includes(Number(value)) ? "Remover" : "Adicionar"}
              </MDButton>
            ),
          },
          {
            Header: "Título",
            accessor: "title",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Data",
            accessor: "slug",
            Cell: ({ cell }: any) => (
              <DefaultCell value={new Date(cell.row.original.dateInit).toLocaleString("pt-BR")} />
            ),
          },
          {
            Header: "Modalidade",
            accessor: "modality",
            Cell: ({ value }: any) => (
              <DefaultCell
                value={value === "HIBRIDA" ? "Híbrida" : value === "ONLINE" ? "Online" : "Presencial"}
              />
            ),
          },
          {
            Header: "Status",
            accessor: "status",
            Cell: ({ value }: any) => getStatusCell(value),
          },
        ]}
      />
    </ModalCustom>
  );
}
